var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"question_con"},_vm._l((_vm.data),function(d,index){return _c('div',{key:index,staticClass:"question_item"},[_c('p',{staticClass:"question"},[_c('span',[_vm._v("Q")]),_vm._v(_vm._s(d.question))]),_c('p',{staticClass:"answer"},[_c('span',[_vm._v("A")]),_vm._v(_vm._s(d.answer))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }